"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _ChinaDisclaimer = _interopRequireDefault(require("../ChinaDisclaimer"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _Spinner = _interopRequireDefault(require("@airasia/phoenix-components/components/Spinner"));

var _constant = require("../constant");

var _MultiRoomSelect = _interopRequireDefault(require("../MultiRoomSelect"));

var _Calendar = _interopRequireDefault(require("../Calendar"));

var _Dropdown = _interopRequireDefault(require("@airasia/phoenix-components/components/Dropdown"));

var _Banner = _interopRequireDefault(require("../Banner"));

var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));

var _lodash = _interopRequireWildcard(require("lodash"));

var _useFetch3 = _interopRequireDefault(require("../Store/useFetch"));

var _ContextualSearchWidget = _interopRequireDefault(require("../ContextualSearchWidget"));

var _dateFns = require("date-fns");

var _hotelSearchWidget = _interopRequireDefault(require("./hotelSearchWidget.proptypes"));

var _constant2 = require("./constant");

var _data = require("./data");

var _services = require("./services");

var _parser = require("./parser");

var _config = require("./config");

var _util = require("./util");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var USWContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelSearchWidget__USWContainer",
  componentId: "sc-1j7h2hg-0"
})(function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile,
      isApplyHotelList = _ref.isApplyHotelList,
      styleBottomBanner = _ref.styleBottomBanner;
  return "\n        display: flex;\n        flex-direction: column;\n        background-color: ".concat(isApplyHotelList ? theme.backgroundColor.primary : theme.backgroundColor.default, ";\n        #returnclick-handle {\n          padding-left: ").concat(theme.fontSize.XXSmall, ";\n        }\n        margin-top ").concat(styleBottomBanner ? theme.space.semiLarge : theme.space.none, ";\n        ").concat(isMobile ? "\n              padding: 0 0;\n            " : "\n              margin-bottom: ".concat(!isApplyHotelList ? theme.space.small : 0, ";\n\n              #HSW-originDestionation {\n                background-color: ").concat(theme.backgroundColor.default, ";\n                & > div:nth-child(2){\n                  width: calc(100% + 50px);\n                }\n              }\n\n              #hsw-search-button-container{\n                & a {\n                  min-width: 150px;\n                }\n              }\n\n              #fsw-multiroom-select{\n                min-width: 205px;\n                & > div{\n                  min-width: 205px;\n                }\n              }\n\n              #hsw-calendar{\n                 min-width: 280px;\n  \n                & > div{\n                  width: 100%;\n                }\n  \n                #departclick-handle > div {\n                  width: 100%;\n                }\n  \n                & #aaCalendar-header{\n                  & > div{\n                    width: 100%;\n                  }\n  \n                  & input{\n                    width: 100%;\n                  }\n                }\n              }\n            "), "\n    ");
});

var USWRow = _styledComponents.default.div.withConfig({
  displayName: "HotelSearchWidget__USWRow",
  componentId: "sc-1j7h2hg-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile;
  return "\n        display: flex;\n        flex: 1;\n        flex-wrap: wrap;\n        ".concat(isMobile ? "\n              flex-direction: column;\n            " : "\n              // &:not(:last-child){\n              //   margin-bottom: ".concat(theme.space.small, ";\n              // }\n            "), "\n\n    ");
});

var getContentStyles = function getContentStyles(theme, isMobileScreen, isBanner) {
  if (isBanner && isMobileScreen) return "padding: 0px";
  if (!isBanner && isMobileScreen) return "padding: ".concat(theme.space.tiny, " ").concat(theme.space.small);
  if (!isBanner && !isMobileScreen) return "&:not(:last-child){\n    margin-right: ".concat(theme.space.standard, ";\n  }");
  return "";
};

var USWContent = _styledComponents.default.div.withConfig({
  displayName: "HotelSearchWidget__USWContent",
  componentId: "sc-1j7h2hg-2"
})(function (_ref3) {
  var theme = _ref3.theme,
      isMobileScreen = _ref3.isMobileScreen,
      isBanner = _ref3.isBanner,
      flexValue = _ref3.flexValue;
  return "\n        flex : ".concat(flexValue, ";\n        ").concat(getContentStyles(theme, isMobileScreen, isBanner), "\n    ");
});

var HotelSearchWidget = function HotelSearchWidget(props) {
  var _roomConfig$;

  var data = props.data,
      viewport = props.viewport,
      theme = props.theme,
      environment = props.environment,
      prefill = props.prefill,
      locale = props.locale,
      closeSearchWidget = props.closeSearchWidget,
      currency = props.currency,
      endpointConfig = props.endpointConfig,
      isSearchWidgetOpenByDefault = props.isSearchWidgetOpenByDefault,
      showContextualSearchWidget = props.showContextualSearchWidget,
      contextualConfig = props.contextualConfig,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      fireGtm = props.fireGtm,
      maxRangeDays = props.maxRangeDays,
      maxDays = props.maxDays,
      onSubmitHandler = props.onSubmitHandler,
      isApplyHotelList = props.isApplyHotelList,
      showBannerBottom = props.showBannerBottom,
      bannerConfig = props.bannerConfig;
  var components = data.components,
      chinaDisclaimer = data.chinaDisclaimer,
      roomConfig = data.roomConfig,
      translations = data.translations;
  var ageList = ((_roomConfig$ = roomConfig[4]) === null || _roomConfig$ === void 0 ? void 0 : _roomConfig$.ageList) || _constant2.AGE_LIST_DEFAULT;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)('false'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showCnDisclaimer = _useState2[0],
      setShowCnDisclaimer = _useState2[1];

  var _useState3 = (0, _react.useState)(viewport === _constant.DEVICE_TYPE.MOBILE),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      locationDestination = _useState6[0],
      setLocationDestination = _useState6[1];

  var _useState7 = (0, _react.useState)({
    checkin: null,
    checkout: null
  }),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      journeyDates = _useState8[0],
      setJourneyDates = _useState8[1];

  var _useState9 = (0, _react.useState)({
    rooms: null
  }),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      passengerRooms = _useState10[0],
      setPassengerRooms = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      recentDestinations = _useState12[0],
      setRecentDestinations = _useState12[1];

  var _useFetch = (0, _useFetch3.default)(null, _constant2.ASYNC_DATA_KEYS.CALENDAR_DATA),
      _useFetch2 = (0, _slicedToArray2.default)(_useFetch, 2),
      calendarDataFormat = _useFetch2[0],
      fetchCalendarDataFormat = _useFetch2[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      renderBanner = _useState14[0],
      setRenderBanner = _useState14[1];

  var cnDisclaimer = chinaDisclaimer[0].data[0];
  var ppConfig = _config.envConfig[environment];

  var _useState15 = (0, _react.useState)(viewport === _constant.DEVICE_TYPE.MOBILE),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      openModal = _useState16[0],
      setOpenModal = _useState16[1];

  var _useState17 = (0, _react.useState)(''),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      redirectionURL = _useState18[0],
      setRedirectionURL = _useState18[1];

  var _useState19 = (0, _react.useState)(true),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      destinationValid = _useState20[0],
      setDestinationValid = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      isSearchSpinner = _useState22[0],
      setSearchSpinner = _useState22[1];

  var _useState23 = (0, _react.useState)((0, _util.constructPassengerData)(roomConfig, translations, (0, _util.prefillSearchCriteria)(roomConfig))),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      paxConfig = _useState24[0],
      setPaxConfig = _useState24[1];

  var _useState25 = (0, _react.useState)([[]]),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      childsAge = _useState26[0],
      setChildsAge = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      openCalendarModal = _useState28[0],
      setOpenCalendarModal = _useState28[1];

  var _useState29 = (0, _react.useState)(!isSearchWidgetOpenByDefault && showContextualSearchWidget),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      openCSW = _useState30[0],
      setOpenCSW = _useState30[1];

  var constructSearchCriteria = function constructSearchCriteria(suggestion) {
    var search = {
      destination: null
    };
    var recentSearch = (0, _parser.parseRecentSearches)((0, _util.getRecentSearches)());
    var hasRecentSearches = Object.keys(recentSearch).length > 0;
    var checkin;
    var checkout; // for destination!!

    if (suggestion) {
      search.destination = suggestion;
    } else if (hasRecentSearches) {
      search.destination = recentSearch.destinations && recentSearch.destinations[0] || null;
    } // eslint-disable-next-line no-unused-expressions


    search.destination && setLocationDestination(search.destination); // setting recentsearches.

    if (hasRecentSearches) {
      setRecentDestinations(recentSearch.destinations);
    } // for checkin, checkout


    if (prefill && prefill.checkin && prefill.checkout) {
      checkin = (0, _util.convertStringToDate)(prefill.checkin);
      checkout = (0, _util.convertStringToDate)(prefill.checkout);
    } else if (hasRecentSearches) {
      checkin = (0, _util.convertStringToDate)(recentSearch.date.checkin);
      checkout = (0, _util.convertStringToDate)(recentSearch.date.checkout);
    } else {
      var currentDt = (0, _util.getCheckinCheckoutDates)();
      checkin = currentDt.checkin;
      checkout = currentDt.checkout;
    }

    if (prefill && prefill.childsAge) {
      setChildsAge(prefill.childsAge);
    }

    search.date = {
      checkin: checkin,
      checkout: checkout
    };
    setJourneyDates(search.date); // roomconfig, prefill roomOccupancy need to verify.

    if (prefill && prefill.roomOccupancy && prefill.roomOccupancy.length > 0) {
      search.rooms = prefill.roomOccupancy;
    } else if (hasRecentSearches) {
      search.rooms = recentSearch.rooms;
    } else {
      search.rooms = (0, _util.prefillSearchCriteria)(roomConfig);
    }

    setPassengerRooms({
      rooms: search.rooms
    });
    var consPaxConfig = (0, _util.constructPassengerData)(roomConfig, translations, search.rooms);
    setPaxConfig(_objectSpread(_objectSpread({}, paxConfig), consPaxConfig));
    setDestinationValid(search.destination && true || false);
  }; // ComponentDidMount


  (0, _react.useEffect)(function () {
    // setting default search criteria.
    if (prefill && Object.keys(prefill).length > 0 && prefill.destination) {
      if (prefill.destination.name) {
        constructSearchCriteria(prefill.destination);
      } else {
        (0, _services.getSuggestions)(prefill.destination, ppConfig, locale, true).then(constructSearchCriteria).catch(function () {
          return constructSearchCriteria();
        });
      }
    } else {
      constructSearchCriteria();
    }
  }, [prefill, translations, roomConfig]); // ComponentDidMount

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('chinadisclaimerclosed', function (e) {
        setShowCnDisclaimer("".concat(e.detail));
      });
    } // ComponentWillUnmount


    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('chinadisclaimerclosed', function (e) {
          setShowCnDisclaimer("".concat(e.detail));
        });
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    setIsMobile(viewport === _constant.DEVICE_TYPE.MOBILE);
  }, [viewport]);
  (0, _react.useEffect)(function () {
    var _ref4 = bannerConfig || {},
        showBanner = _ref4.showBanner;

    if (showBannerBottom && showBanner && showBanner === 'TRUE') {
      setRenderBanner(true);
    } else {
      setRenderBanner(false);
    }
  }, [showBannerBottom, bannerConfig]);
  var dateFormatApiCallBasedOnLocale = (0, _react.useCallback)(function (lang) {
    var dateUrl = (0, _util.formatEndpointURL)((0, _util.getEndpointURL)(endpointConfig, 'dateFormat'), environment).replace('{locale}', lang);
    fetchCalendarDataFormat({
      url: dateUrl,
      method: _constant.HTTPS_METHOD.GET
    });
  }, [endpointConfig, environment, fetchCalendarDataFormat]);
  (0, _react.useEffect)(function () {
    dateFormatApiCallBasedOnLocale(locale);
  }, [dateFormatApiCallBasedOnLocale, locale]);

  var searchHandler = function searchHandler() {
    setSearchSpinner(true);

    if (destinationValid && locationDestination && journeyDates.checkin && journeyDates.checkout && passengerRooms.rooms && childsAge) {
      var isChinaDomain = _utilities.default.isChinaDomainName();

      var redirctURL = ppConfig[isChinaDomain ? 'chinaRedirectionURL' : 'redirectionURL'];
      var criteria = {
        destination: locationDestination,
        checkin: journeyDates.checkin,
        checkout: journeyDates.checkout,
        rooms: passengerRooms.rooms,
        childsAge: childsAge
      };
      var roomDataGtm = criteria.rooms.length > 0 ? criteria.rooms.reduce(function (acc, item) {
        return {
          adult: acc.adult + item.adult,
          child: acc.child + item.child,
          infant: acc.infant + item.infant
        };
      }) : false;
      var eventLabelGtm = "".concat(criteria.destination.name, "(recent.hs.list)|").concat((0, _dateFns.format)(criteria.checkin, 'yyyy-MM-dd'), "-").concat((0, _dateFns.format)(criteria.checkout, 'yyyy-MM-dd'), "|").concat(criteria.rooms.length, "Rooms|ADL=").concat(roomDataGtm ? roomDataGtm.adult : 0, ",CHD=").concat(roomDataGtm ? roomDataGtm.child : 0, ",INF=").concat(roomDataGtm ? roomDataGtm.infant : 0); // GTM

      var objGtm = {
        event: 'trackEventNoEcommerce',
        'eventDetails.category': 'Hotels SA|hotelsearchwidget',
        'eventDetails.action': "click",
        'eventDetails.label': eventLabelGtm
      };
      if (objGtm && fireGtm) fireGtm(objGtm, 'true');
      var url = (0, _util.getHotelRedirectionURL)(criteria, redirctURL, locale, currency);
      setRedirectionURL(url);

      if (locationDestination.full_name) {
        (0, _util.saveRecentSearches)(criteria);
      }

      if (isChinaDomain) {
        setShowCnDisclaimer('true');
      } else {
        if (viewport === _constant.DEVICE_TYPE.MOBILE) setOpenModal(false);
        setSearchSpinner(false);

        if (isOnlyApplyForHotel && onSubmitHandler) {
          onSubmitHandler(criteria);
        } else {
          window.open(url, '_parent');
        }
      }
    } else {
      setSearchSpinner(false);
    }
  };

  var formatDefaultValue = function formatDefaultValue(dest) {
    return dest ? _objectSpread(_objectSpread({}, dest), {}, {
      mainDisplayName: dest.name
    }) : null;
  };

  var getDropdownConfig = function getDropdownConfig(config) {
    var LOCALE = translations[0].data[0];
    var LABEL = config.label1;
    var DEFAULT_ICON = config.iconName;
    var PLACE_HOLDER = config.placeholderText;
    var PLACE_HOLDER_ITEMS = config.defaultLocation ? [config.defaultLocation] : config.placeholderItems; // we need to use recommendedStations, rather than placeholderItems!!.

    var ID = "HSW-".concat(config.id);
    var destinationUserTypedValue = null;
    var isUserClickRecentSearch = true;

    var onchangeHandler = _lodash.default.debounce( /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, callback) {
        var suggestions, parsedSuggestions;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value && value.length >= 3)) {
                  _context.next = 8;
                  break;
                }

                destinationUserTypedValue = value;
                isUserClickRecentSearch = false;
                _context.next = 5;
                return (0, _services.getSuggestions)(value, ppConfig, locale);

              case 5:
                suggestions = _context.sent;
                parsedSuggestions = (0, _parser.parseSuggestions)(suggestions);
                callback(parsedSuggestions);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref5.apply(this, arguments);
      };
    }(), 500);

    var OnselectHandler = function OnselectHandler(res) {
      setDestinationValid(true);
      setLocationDestination(_objectSpread(_objectSpread({}, res), {}, {
        isClickedDestinationItem: true
      })); // eslint-disable-next-line no-unused-expressions

      viewport === 'desktop' && setOpenCalendarModal(true); // GTM

      var objGtm = {
        event: 'trackEventNoEcommerce',
        'eventDetails.category': 'Hotels SA|hotelsearchwidget',
        'eventDetails.action': "click",
        'eventDetails.label': "".concat(destinationUserTypedValue || locationDestination.name, "(").concat(isUserClickRecentSearch ? 'recent.hs.list' : 'gnral', ")|").concat(res.name, "|").concat(res.type)
      };
      if (objGtm && fireGtm) fireGtm(objGtm, 'true');
    }; // const recentSearch = parseRecentSearches(getRecentSearches());


    var dropdownConfig = {
      hideMobileIcon: viewport === _constant.DEVICE_TYPE.MOBILE,
      viewPort: viewport,
      label: LABEL,
      locale: LOCALE,
      defaultIcon: DEFAULT_ICON,
      placeHolder: PLACE_HOLDER,
      placeHolderItems: PLACE_HOLDER_ITEMS,
      items: recentDestinations || null,
      onChange: onchangeHandler,
      onSelect: OnselectHandler,
      isValidField: function isValidField(status) {
        return setDestinationValid(status);
      },
      defaultValue: formatDefaultValue(locationDestination),
      accessible: false,
      width: '100%',
      theme: theme,
      id: ID,
      highlightText: true,
      isOnlyApplyForHotel: isOnlyApplyForHotel
    };
    return dropdownConfig;
  };

  var calenderSelectionHandler = function calenderSelectionHandler(selectedDate) {
    setJourneyDates(function (prvState) {
      if (prvState && prvState.checkin !== selectedDate.dates.departureDate) prvState.checkin = selectedDate.dates.departureDate;
      if (prvState && prvState.checkout !== selectedDate.dates.returnDate) prvState.checkout = selectedDate.dates.returnDate;
      return prvState;
    });
  };

  var getBottomBannerConfig = function getBottomBannerConfig() {
    var _ref6 = bannerConfig || {},
        imageURL = _ref6.imageURL,
        headline = _ref6.headline,
        subheadline = _ref6.subheadline,
        headlineColor = _ref6.headlineColor,
        subheadlineColor = _ref6.subheadlineColor,
        buttonText = _ref6.buttonText,
        buttonUrl = _ref6.buttonUrl,
        redirectUrl = _ref6.redirectUrl,
        showBanner = _ref6.showBanner; // console.log({
    //   imageURL,
    //   headline,
    //   subheadline,
    //   headlineColor,
    //   subheadlineColor,
    //   buttonText,
    //   buttonUrl,
    // });


    var position = 1; // event call when view

    var objGtm = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': 'Hotels SA|herobanner',
      'eventDetails.action': "view",
      'eventDetails.label': "".concat(headline, "|").concat(position)
    };
    if (objGtm && fireGtm) fireGtm(objGtm, 'true');
    return {
      gtmEventData: {
        event: 'trackEventNoEcommerce',
        'eventDetails.category': 'Hotels SA|herobanner',
        'eventDetails.action': "click",
        'eventDetails.label': "".concat(headline, "|").concat(position)
      },
      fireGtm: fireGtm,
      redirectUrl: redirectUrl,
      imageURL: imageURL,
      headline: headline,
      subheadline: subheadline,
      headlineColor: headlineColor,
      subheadlineColor: subheadlineColor,
      buttonText: buttonText,
      buttonUrl: buttonUrl,
      showBanner: showBanner
    };
  }; // const getCalenderConfig = (config) => {
  //   return {
  //     theme,
  //     disableOneway: true,
  //     labelDepart: config.label1, // 'Check-in',
  //     labelReturn: config.label2, // 'Check-out',
  //     dateFormatData: DATE_FORMAT_DATA,
  //     maxDays: 300,
  //     viewType: viewport,
  //     calendarOutputdata: calenderSelectionHandler,
  //     customProperties: {
  //       id: 'hsw-calendar',
  //     },
  //   };
  // };


  var onRoomSelection = function onRoomSelection(paxCount, newChildAge) {
    setPassengerRooms({
      rooms: paxCount
    });
    if (newChildAge) setChildsAge(newChildAge);
  };

  var getRoomSelectConfig = function getRoomSelectConfig(componentData) {
    var _passengerRooms$rooms;

    var isShowChildAgeInput = !!(componentData && componentData.enableAgeInput && componentData.enableAgeInput === 'TRUE');
    var isShowInfantSelect = !(componentData && componentData.hideInfantSelect && componentData.hideInfantSelect === 'TRUE');
    return {
      theme: theme,
      data: _objectSpread(_objectSpread({}, paxConfig), {}, {
        labels: translations[0].data[0],
        roomOccupancy: ((_passengerRooms$rooms = passengerRooms.rooms) === null || _passengerRooms$rooms === void 0 ? void 0 : _passengerRooms$rooms.length) > 0 ? passengerRooms.rooms : _constant2.DEFAULT_ROOM_OCCUPANCY,
        ageList: ageList || _constant2.AGE_LIST_DEFAULT,
        childAgeData: childsAge,
        placeHolder: {
          childAgeDropdownLabel: 'Child {0} age'
        }
      }),
      onChangeData: onRoomSelection,
      device: viewport,
      alwayEnableAddRoom: true,
      isShowChildAgeInput: isShowChildAgeInput,
      isShowInfantSelect: isShowInfantSelect,
      customProperties: {
        id: 'fsw-multiroom-select'
      }
    };
  };

  var setButtonCustomProperties = function setButtonCustomProperties(isLoading) {
    return isLoading ? {
      paddingLeft: '0',
      paddingRight: '0',
      paddingTop: '8px',
      paddingBottom: '8px'
    } : {
      paddingLeft: '0',
      paddingRight: '0',
      paddingTop: '17px',
      paddingBottom: '17px'
    };
  };

  var getSearchBtn = function getSearchBtn(label) {
    return /*#__PURE__*/_react.default.createElement("span", {
      id: "hsw-search-button-container"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      disabled: isSearchSpinner,
      defaultDisabledFeatures: false,
      backgroundColor: "primary",
      color: "default",
      theme: theme,
      handleClick: searchHandler,
      width: "100%",
      customProperties: setButtonCustomProperties(isSearchSpinner)
    }, !isSearchSpinner ? label : /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      animationDuration: "0.5s",
      color: "default",
      height: "35px",
      show: true,
      strokeWidth: "4",
      theme: theme,
      width: "35px"
    })));
  };

  var callbackOpenCalendarModal = function callbackOpenCalendarModal(val) {
    setOpenCalendarModal(val); // should foucs on passenger room selection!!
  };

  var generateComponentWidget = function generateComponentWidget(compWidgetData) {
    var type = compWidgetData.type,
        label1 = compWidgetData.label1,
        label2 = compWidgetData.label2;

    switch (type) {
      case _constant2.USW_COMPONENT_TYPES.HERO_BANNER:
        return /*#__PURE__*/_react.default.createElement(_Banner.default, {
          showBackNavigation: true,
          backNavigationHandler: function backNavigationHandler() {
            setOpenModal(false); // eslint-disable-next-line no-unused-expressions

            closeSearchWidget && closeSearchWidget(); // only for mobile web.
          },
          imageURL: compWidgetData.imageUrl,
          height: "154px",
          theme: theme,
          isOnlyApplyForHotel: true
        });

      case _constant2.USW_COMPONENT_TYPES.PLACEPICKER:
        return /*#__PURE__*/_react.default.createElement(_Dropdown.default, getDropdownConfig(compWidgetData));

      case _constant2.USW_COMPONENT_TYPES.DATEPICKER:
        return /*#__PURE__*/_react.default.createElement(_Calendar.default, {
          theme: theme,
          disableOneway: true,
          labelDepart: label1,
          labelReturn: label2,
          openCalendarModal: openCalendarModal,
          callbackOpenCalendarModal: callbackOpenCalendarModal,
          dateFormatData: calendarDataFormat && !calendarDataFormat.isFetching && !calendarDataFormat.isError ? calendarDataFormat.data : _data.DATE_FORMAT_DATA // dateFormatData={DATE_FORMAT_DATA}
          ,
          maxDays: maxDays !== null && maxDays !== void 0 ? maxDays : 300,
          maxRangeDays: maxRangeDays,
          viewType: viewport,
          calendarOutputdata: calenderSelectionHandler,
          customProperties: {
            id: 'HSW-calendar'
          },
          prefillDefaultDepart: journeyDates.checkin,
          prefillDefaultReturn: journeyDates.checkout,
          isOnlyApplyForHotel: isOnlyApplyForHotel
        });

      case _constant2.USW_COMPONENT_TYPES.PAX_COUNTER:
        return null;

      case _constant2.USW_COMPONENT_TYPES.MULTI_ROOM_SELECT:
        return /*#__PURE__*/_react.default.createElement(_MultiRoomSelect.default, (0, _extends2.default)({}, getRoomSelectConfig(compWidgetData), {
          isOnlyApplyForHotel: true
        }));

      case _constant2.USW_COMPONENT_TYPES.DROPDOWN:
        return null;

      case _constant2.USW_COMPONENT_TYPES.LINK:
        return null;

      case _constant2.USW_COMPONENT_TYPES.CHECKBOX:
        return null;

      case _constant2.USW_COMPONENT_TYPES.BUTTON:
        return getSearchBtn(label1);

      default:
        return null;
    }
  };

  var generateStyleComponentWidget = function generateStyleComponentWidget(type) {
    switch (type) {
      case _constant2.USW_COMPONENT_TYPES.HERO_BANNER:
        return {
          flexValue: 1
        };

      case _constant2.USW_COMPONENT_TYPES.PLACEPICKER:
        return {
          flexValue: 2
        };

      case _constant2.USW_COMPONENT_TYPES.DATEPICKER:
        return {
          flexValue: 1
        };

      case _constant2.USW_COMPONENT_TYPES.PAX_COUNTER:
        return null;

      case _constant2.USW_COMPONENT_TYPES.MULTI_ROOM_SELECT:
        return {
          flexValue: 1
        };

      case _constant2.USW_COMPONENT_TYPES.DROPDOWN:
        return null;

      case _constant2.USW_COMPONENT_TYPES.LINK:
        return null;

      case _constant2.USW_COMPONENT_TYPES.CHECKBOX:
        return null;

      case _constant2.USW_COMPONENT_TYPES.BUTTON:
        return {
          flexValue: 1
        };

      default:
        return null;
    }
  };

  var checkElementVisibility = function checkElementVisibility(d) {
    var showInDesktop = d.showInDesktop,
        showInMobile = d.showInMobile; // Check if component/widget will be visible to mobile

    if (isMobile) {
      if (_utilities.default.checkStringBoolean(showInMobile)) {
        return generateComponentWidget(d);
      }
    } // Check if component/widget will be visible to desktop


    if (_utilities.default.checkStringBoolean(showInDesktop)) {
      return generateComponentWidget(d);
    }

    return null;
  };

  var searchWidgetInteractHandler = function searchWidgetInteractHandler() {
    if (!isSearchWidgetOpenByDefault) {
      return;
    }

    setOpenCSW(true);
  };

  var getContainer = function getContainer() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(USWContainer, {
      isApplyHotelList: isApplyHotelList,
      id: "hotel-search-widget",
      onClick: searchWidgetInteractHandler,
      isMobile: isMobile
    }, // eslint-disable-next-line react/prop-types
    components.map(function (comp) {
      var compData = comp.data;
      return /*#__PURE__*/_react.default.createElement(USWRow, {
        key: Math.random(),
        isMobile: isMobile
      }, compData.map(function (d) {
        var ele = checkElementVisibility(d);

        if (ele === null) {
          return _lodash.isNull;
        }

        var componentStyle = generateStyleComponentWidget(d.type);
        return /*#__PURE__*/_react.default.createElement(USWContent, (0, _extends2.default)({
          isMobileScreen: isMobile,
          isBanner: d.type === _constant2.USW_COMPONENT_TYPES.HERO_BANNER
        }, componentStyle), ele);
      }));
    })), renderBanner && /*#__PURE__*/_react.default.createElement(USWContainer, {
      styleBottomBanner: true
    }, /*#__PURE__*/_react.default.createElement(_Banner.default, (0, _extends2.default)({
      theme: theme
    }, getBottomBannerConfig()))), openCSW && /*#__PURE__*/_react.default.createElement(_ContextualSearchWidget.default, (0, _extends2.default)({}, contextualConfig, {
      config: _objectSpread(_objectSpread({}, contextualConfig.config), {}, {
        product: _constant2.DEFAULT_CONTEXTUAL_PRODUCT_ID,
        viewport: viewport
      })
    })), showCnDisclaimer === 'true' && /*#__PURE__*/_react.default.createElement(_ChinaDisclaimer.default, {
      content: [cnDisclaimer],
      productId: "hotels",
      theme: theme,
      redirect: redirectionURL
    }));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewport === 'mobile' ? /*#__PURE__*/_react.default.createElement(_Modal.default, {
      openModal: openModal,
      viewPort: viewport,
      fullScreen: true,
      showCloseIcon: false,
      zIndex: "999999"
    }, getContainer()) : getContainer()); // return (
    //   <>
    //   <Modal openModal={true} viewPort={viewport} fullScreen={true}>
    //     <USWContainer isMobile={isMobile}>
    //       {
    //         // eslint-disable-next-line react/prop-types
    //         components.map((comp) => {
    //           const compData = comp.data;
    //           return (
    //             <USWRow key={Math.random()} isMobile={isMobile}>
    //               {compData.map((d) => {
    //                 const ele = checkElementVisibility(d);
    //                 if (ele === null) {
    //                   return isNull;
    //                 }
    //                 return <USWContent isMobile={isMobile}>{ele}</USWContent>;
    //               })}
    //             </USWRow>
    //           );
    //         })
    //       }
    //     </USWContainer>
    //     </Modal>
    //     {showCnDisclaimer === 'true' && (
    //       <ChinaDisclaimer content={[cnDisclaimer]} productId="hotels" theme={theme} redirect={redirectUrl} />
    //     )}
    //   </>
    // );
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

HotelSearchWidget.propTypes = _hotelSearchWidget.default.PropTypes;
HotelSearchWidget.defaultProps = _hotelSearchWidget.default.DefaultProps;
var _default = HotelSearchWidget;
exports.default = _default;